const clientList = [
    { Artist: "GAZOLE", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "GRUBBESKOLAN", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "HIGH 5", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "HOW IT STRIKES", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "HOWLIN HARPERS", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "IGNORANS", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "INDIEKID AURELIA", WorkType: "Mastering" },
    { Artist: "IVY MIKE", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "JOE FIDDLE", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "FIRE LEGION", WorkType: "Recording / Mixing" },
    { Artist: "JA!", WorkType: "Mixing" },
    { Artist: "JOHAN KNUTSSON", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "JOHAN NYBOM", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "KARAKOU, Zebra Session", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "KLARTECKEN", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "KRISTOFER BLOMBERG", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "LOOK, ORION!", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "LUA LEE", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "MATES OF MINE", WorkType: "Recording / Mixing" },
    { Artist: "MIKAEL ELOFSSON BIG SMALL BAND", WorkType: "Recording / Editing" },
    { Artist: "MONA ERSARE", WorkType: "Mixing / Mastering" },
    { Artist: "OH SO SERENE", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "PIERRE DACKMO", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "ROUGH TIMES", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "RÅET", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "SAMUELS TANKAR", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "SLUMBER", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "SONIC KHARMA", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "STAFFAN ÖBERG NONET", WorkType: "Recording / Mixing" },
    { Artist: "STEN ÖBERGS GULLINGRUPP", WorkType: "Recording / Editing" },
    { Artist: "TEGSKYRKAN", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "THE FASHION BARBIE DOLL", WorkType: "Prod / Recording / Mixing / Mastering" },
    { Artist: "THE MAGIC BOX", WorkType: "Prod / Recording" },
    { Artist: "THE STETHOSCOPE", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "TINY PEACHES", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "VK/VF PODCAST", WorkType: "Edit / Mixing" },
    { Artist: "WALLFLOWERS", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "WEEKEND PARADE", WorkType: "Prod / Recording / Mixing / Mastering" },
    { Artist: "WILD FIELDS", WorkType: "Recording / Mixing / Mastering" },
    { Artist: "ZEBRA SESSIONS", WorkType: "Recording / Mixing / Mastering" },
];

export const Audiowork = () => {
    return (
        <div>
            <p className="text-red-500 font-mono text-xs uppercase tracking-widest text-center mb-3">Sound work</p>
            <h3 className="text-2xl font-bold text-white text-center mb-4">Audio Clients</h3>
            <p className="text-gray-400 text-center mb-10 text-sm">
                A glimpse of some remarkable collaborations over the years:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {clientList.map((client, index) => (
                    <div key={index} className="bg-neutral-900 border border-neutral-800 hover:border-red-900 p-4 transition-colors duration-200">
                        <p className="text-white font-bold font-mono text-sm">{client.Artist}</p>
                        <p className="text-gray-500 text-xs mt-1">{client.WorkType}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

